export const CHUNK_RECOVERY_MARKER_KEY = "ish:chunk-recovery-v3";
export const CHUNK_RECOVERY_HISTORY_KEY = "__ishChunkRecoveryV3";
export const CHUNK_RELOAD_COOLDOWN_MS = 30_000;
export const CHUNK_RECOVERY_CONFIRM_MS = 8_000;
export const CHUNK_RECOVERY_MARKER_TTL_MS = 5 * 60_000;
